import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ApplicationEventService {
  private readonly PROJECT_ID_KEY = 'Project ID';

   /**
   * Creates a new certificate
   * @param {String} projectID Id of the project */
  public clickOnTheCreateButtonInTheCertificatesDialog(projectID) {
    if (projectID === undefined) {
      return undefined;
    }

    const name = 'Click On The Create Button In The Certificates Dialog';
    const properties = {};
    properties[this.PROJECT_ID_KEY] = projectID;
    return { name, properties };
  }

  /**
   * Opens the dialog to add a new certificate
   * @param {String} projectID Id of the project */
  public clickOnTheCreateCertificateButtonInTheProjectBuildingIntegrationsPage(projectID) {
    if (projectID === undefined) {
      return undefined;
    }

    const name = 'Click On The Create Certificate Button In The Project Building Integrations Page';
    const properties = {};
    properties[this.PROJECT_ID_KEY] = projectID;
    return { name, properties };
  }

  /**
   * Deletes the certificate
   * @param {String} projectID Id of the project
   */
  public clickOnTheDeleteButtonInTheDeleteCertificateDialog(projectID) {
    if (projectID === undefined) {
      return undefined;
    }

    const name = 'Click On The Delete Button In The Delete Certificate Dialog';
    const properties = {};
    properties[this.PROJECT_ID_KEY] = projectID;
    return { name, properties };
  }

  /**
   * Opens the confirmation dialog to delete the certificate
   * @param {String} projectID Id of the project */
  public clickOnTheDeleteOptionInTheCertificatesTable(projectID) {
    if (projectID === undefined) {
      return undefined;
    }

    const name = 'Click On The Delete Option In The Certificates Table';
    const properties = {};
    properties[this.PROJECT_ID_KEY] = projectID;
    return { name, properties };
  }

  /**
   * Downloads the json file
   * @param {String} projectID Id of the project */
  public clickOnTheDownloadIconInTheProjectBuildingIntegrationsPage(projectID) {
    if (projectID === undefined) {
      return undefined;
    }

    const name = 'Click On The Download Icon In The Project Building Integrations Page';
    const properties = {};
    properties[this.PROJECT_ID_KEY] = projectID;
    return { name, properties };
  }

  /**
   * Download the certificate zip file
   * @param {String} projectID Id of the project */
  public clickOnTheDownloadOptionInCertificatesTable(projectID) {
    if (projectID === undefined) {
      return undefined;
    }

    const name = 'Click On The Download Option In Certificates Table';
    const properties = {};
    properties[this.PROJECT_ID_KEY] = projectID;
    return { name, properties };
  }

    /**
   * Cancels the certificate creation
   * @param {String} projectID Id of the project */
  public clickOnTheCancelButtonInTheCertificatesDialog(projectID) {
    if (projectID === undefined) {
      return undefined;
    }

    const name = 'Click On The Cancel Button In The Certificates Dialog';
    const properties = {};
    properties[this.PROJECT_ID_KEY] = projectID;
    return { name, properties };
  }

    /**
   * Cancels the deletion of certificates
   * @param {String} projectID Id of the project */
  public clickOnTheCancelButtonInTheDeleteCertificateDialog(projectID) {
    if (projectID === undefined) {
      return undefined;
    }

    const name = 'Click On The Cancel Button In The Delete Certificate Dialog';
    const properties = {};
    properties[this.PROJECT_ID_KEY] = projectID;
    return { name, properties };
  }
}
